import { render, staticRenderFns } from "./index.vue?vue&type=template&id=72aacfda&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=72aacfda&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72aacfda",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\iotcarduserui\\iotcardpc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72aacfda')) {
      api.createRecord('72aacfda', component.options)
    } else {
      api.reload('72aacfda', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=72aacfda&scoped=true", function () {
      api.rerender('72aacfda', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/seal/index.vue"
export default component.exports